module.exports = __webpack_public_path__ + "img/smok.85fa40e9.png";